export default __webpack_public_path__ + "static/media/mkv2.76a386de.jpg";